module.exports = __webpack_public_path__ + "img/bind-ok-action.887e3d8e.png";